import { render } from "./saleGoods.vue?vue&type=template&id=dcd0a19e&scoped=true"
import script from "./saleGoods.vue?vue&type=script&lang=js"
export * from "./saleGoods.vue?vue&type=script&lang=js"

import "./saleGoods.vue?vue&type=style&index=0&id=dcd0a19e&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd0a19e"]])

export default __exports__